export enum EducationMode {
  Online = "Online",
  Presence = "Presence",
}
